import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import Hero from "../sections/Hero";
import Marquee from "../sections/Marquee";
import VideoPorDentro from "../sections/VideoPorDentro";
import Historia from "../sections/Historia";
import Problema from "../sections/Problema";
import Producto from "../sections/Producto";
import InteriorGaleria from "../sections/InteriorGaleria";
import Especialidades from "../sections/Especialidades";
import Colores from "../sections/Colores";
import Colecciones from "../sections/Colecciones";
import PackEspecialidades from "../sections/PackEspecialidades";
import Boligrafos from "../sections/Boligrafos";
import Imanes from "../sections/Imanes";
import Infantil from "../sections/Infantil";
import Regalo from "../sections/Regalo";
import Beneficios from "../sections/Beneficios";
import ParaQuien from "../sections/ParaQuien";
import Opiniones from "../sections/Opiniones";
import Faq from "../sections/Faq";
import SobreMi from "../sections/SobreMi";
import Colaboraciones from "../sections/Colaboraciones";
import Contacto from "../sections/Contacto";
import { scrollToId } from "../lib/scroll";

export default function Home() {
  const location = useLocation();

  // Count the visit once per browser session.
  useEffect(() => {
    if (!sessionStorage.getItem("vitae_visited")) {
      sessionStorage.setItem("vitae_visited", "1");
      api.post("/track/visit").catch(() => {});
    }
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => scrollToId(id), 400);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <VideoPorDentro />
      <Historia />
      <Problema />
      <Producto />
      <InteriorGaleria />
      <Especialidades />
      <Colores />
      <Colecciones />
      <Boligrafos />
      <Imanes />
      <Infantil />
      <PackEspecialidades />
      <Regalo />
      <Beneficios />
      <ParaQuien />
      <Opiniones />
      <Faq />
      <SobreMi />
      <Colaboraciones />
      <Contacto />
    </main>
  );
}
